// polyfills for ie11
import 'core-js/features/dom-collections/for-each';
import 'core-js/features/array/fill';

import React from "react";
import ReactDOM from "react-dom";
import Form from './components/Form';
import '../assets/scss/style.scss';
import { hydrateDateToEntry } from "./filter";

const lists = document.querySelectorAll('.pt-react-teaserlist');
lists.forEach(list => {
	if ('true' === list.getAttribute('data-mounted')) {
		return;
	}

	// add missing date strings (parsed from title)
	// eslint-disable-next-line prefer-const
	let items = window[ list.getAttribute('data-list-item-var-name') ];
	items.forEach((item, index, array) => array[ index ] = hydrateDateToEntry(item));

	ReactDOM.render(
		<Form
			language={ list.getAttribute('data-lang') }
			items={ items }
		/>,
		list,
		() => {
			list.setAttribute('data-mounted', 'true');
		}
	);
});
